module.exports = __webpack_public_path__ + "static/shape3-4ae3e0715636d952fa447a1733c68f8e.png";